



















































import { Component, Vue, Prop } from 'vue-property-decorator'
import GoodSelect from '@/components/goods-select/index.vue'
@Component({
  components: {
    GoodSelect,
  },
})
export default class Bargain extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: {
      buyMethod: 0,
      bargainMethod: 0,
      allowBargainOwn: false,
      lowBargainCount: 0,
      validHours: 0,
      description: '',
    },
  })
  value!: any
}
